// Modules
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
// Services
import { NgProgress } from '@ngx-progressbar/core';
import { IntlService } from '@progress/kendo-angular-intl';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfirmationComponent } from '../../../../shared/components/confirmation/confirmation.component';
import { ListeableComponent } from '../../../../shared/components/interfaces/listeable.component';
import { ProductSelectorDialogComponent } from '../../../../shared/components/product-selector-dialog/product-selector-dialog.component';
import { ConfirmationModel } from '../../../../shared/model/confirmation.model';
import { NgSelectOptionModel } from '../../../../shared/model/ng-select-option.model';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { SortUtils } from '../../../../shared/utils/sort.utils';
import { ProductUIMessages } from '../../../product/model/product-ui.messages';
import { ProductService } from '../../../product/service/product.service';
import { AuthService } from '../../../security/service/auth.service';
import { AssetRoutingStates } from '../../asset-routing.module';
import { AssetService } from '../../service/asset.service';
// Utils
import { AssetBaseComponent } from '../asset-base.component';
// Components
import { AssetListResultComponent } from '../asset-list-results/asset-list-results.component';
// Model
import {
  AssetFilterModel,
  AssetStoreFilter
} from '../model/asset-filter.model';
import { AssetSearchStoredInfoModel } from '../model/asset-search-stored-info.model';
import { AssetSearchModel } from '../model/asset-search.model';
import { AssetTypeModel } from '../model/asset-type.model';
import { AssetUIMessages } from '../model/asset-ui.messages';
import { AssetModel } from '../model/asset.model';

export interface AssetBulkMessages {
  MESSAGE: string;
  CONFIRMATION: string;
  SUCCESS: string;
  ERROR: string;
}

@Component({
  selector: 'asset-list',
  templateUrl:
    'console/app-js/modules/asset/components/list/asset-list.component.html'
})
export class AssetListComponent extends AssetBaseComponent
  implements ListeableComponent, OnInit {
  @ViewChild('assetListResultComponent', { static: true })
  public dataTableComponent: AssetListResultComponent;
  private filterModel = new AssetFilterModel();
  private searchModel = new AssetSearchModel();
  private assetStoreFilter = new AssetStoreFilter();
  protected fullScreen = false;
  private searchParamsToEncode = [
    'siteId',
    'serialNumber',
    'showInactive',
    'assetType',
    'assetTagPresent',
    'tag',
    'make',
    'makeId',
    'model',
    'updatedBy'
  ];
  protected deleting = false;
  protected selectedRows = [];
  protected inactiveSelectedRows = [];
  protected loadingIndicator = false;
  protected selectedSite: any = null;
  protected makes: Array<NgSelectOptionModel>;
  protected makesData: Array<NgSelectOptionModel>;
  protected makeFilterSelected: any = '';
  protected assetTypes: Array<AssetTypeModel>;
  protected assetTypesData: Array<AssetTypeModel>;
  public allAssetTagPresent: Array<any> = [];
  public allInactiveActive: Array<any> = [];
  public selectedCustomerType: Array<any> = [];
  public selectedAssetType: Array<any> = [];
  public selectedInactiveRecord: Array<any> = [];
  public selectedAssetTagPresent: Array<any> = [];
  protected originalData: Array<any>;
  protected allCustomersData: Array<NgSelectOptionModel>;
  private assetSearchStoredInfo: AssetSearchStoredInfoModel;
  protected loading = false;
  public noResults = false;
  public assetId: any;

  protected assetTagPresentOptions = [
    { id: 'true', text: 'Tag Present Only' },
    { id: 'false', text: 'Tag Not Present Only' },
    { id: 'trueAndFalse', text: 'Present and Not Present' }
  ];

  protected includeInactiveRecordsOptions = [
    { id: false, text: 'Active Only' },
    { id: true, text: 'Active and Inactive' }
  ];

  constructor(
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    assetService: AssetService,
    productService: ProductService,
    protected dialogService: UIDialogService,
    private router: Router,
    private intl: IntlService
  ) {
    super(
      progressService,
      toastr,
      authService,
      assetService,
      productService,
      dialogService
    );
    this.makesData = [];
    this.allCustomersData = [];
    this.loadMakesList();
    this.loadAssetTypes();
  }

  ngOnInit(): void {
    this.searchModel = this.assetService.getAssetSearchInput();
    this.filterModel = this.searchModel.filterModel;
    this.assetStoreFilter = this.searchModel.assetStoreFilter;
    this.searchModel.pageNumber = 1;
    this.getAllAssetTagPresent();
    this.getAllInactiveActive();
    this.assetSearchStoredInfo = this.assetService.getAssetSearchStoredInfo();
    // if nothing is set in records status then set to active
    if (this.selectedInactiveRecord === undefined) {
      this.selectedInactiveRecord = Object.assign(
        this.includeInactiveRecordsOptions[0]
      );
    }
    // if nothing is set in asset tag present then set to "Present and Not Present"
    if (this.selectedAssetTagPresent === undefined) {
      this.selectedAssetTagPresent = Object.assign(
        this.assetTagPresentOptions[2]
      );
      // this.onSelectedonAssetTagPresent(this.selectedAssetTagPresent);
    }
    this.loadCustomers().subscribe(() => {
      if (this.allCustomers && this.allCustomers.length > 0) {
        this.allCustomersData = this.allCustomers;
        // show selected value
        let activeId = this.searchModel.filterModel.customerId;
        if (activeId != null) {
          // this.customerSelect.active = [this.allCustomers.find(x => x.id === activeId)];
          this.filterModel.customerId = this.searchModel.filterModel.customerId;
          this.filterModel.siteId = this.searchModel.filterModel.siteId;
          // this.filterModel.showInactive = this.searchModel.filterModel.showInactive;
          const res = this.allCustomers.filter(
            cust => cust.id === this.filterModel.customerId
          )[0];
          let indexRes = this.allCustomers.indexOf(res);
          this.selectedCustomerType = Object.assign(
            this.allCustomers[indexRes]
          );
          // this.selectedCustomerType = this.searchModel.assetStoreFilter.selectedCustomer;
        } else {
          this.filterModel.customerId = null;
          this.customerSelect.active = [this.allCustomers[0]];
          // default value save to service
          let selectedCustomer: NgSelectOptionModel = {
            id: this.allCustomers[0].id,
            text: this.allCustomers[0].text
          };

          this.assetSearchStoredInfo.customer = selectedCustomer;
          this.assetService.setAssetSearchStoredInfo(
            this.assetSearchStoredInfo
          );
        }
      }
    });
    if (this.searchModel.results.length > 0) {
      this.onSearch();
    }
  }
  clearFilters() {
    this.filterModel = new AssetFilterModel();
    this.searchModel = new AssetSearchModel();
    this.assetStoreFilter = new AssetStoreFilter();
    this.assetSearchStoredInfo = new AssetSearchStoredInfoModel();

    this.assetService.setAssetSearchInput(this.searchModel);
    this.assetService.setAssetSearchStoredInfo(this.assetSearchStoredInfo);

    this.selectedInactiveRecord = Object.assign(
      this.includeInactiveRecordsOptions[0]
    );

    this.selectedAssetTagPresent = Object.assign(
      this.assetTagPresentOptions[2]
    );
    this.selectedCustomerType = null;
    this.selectedAssetType = null;
    this.makeFilterSelected = null;
  }
  clearAssetID() {
    this.assetId = '';
    this.filterModel = new AssetFilterModel();
    this.searchModel = new AssetSearchModel();
    this.assetStoreFilter = new AssetStoreFilter();
    this.assetSearchStoredInfo = new AssetSearchStoredInfoModel();

    this.assetService.setAssetSearchInput(this.searchModel);
    this.assetService.setAssetSearchStoredInfo(this.assetSearchStoredInfo);

    this.selectedInactiveRecord = Object.assign(
      this.includeInactiveRecordsOptions[0]
    );

    this.selectedAssetTagPresent = Object.assign(
      this.assetTagPresentOptions[2]
    );
    this.selectedCustomerType = null;
    this.selectedAssetType = null;
    this.makeFilterSelected = null;
  }

  /**
   * Get the list of makes
   */
  protected loadMakesList() {
    this.productService.getProductMakesForNgSelect().subscribe(
      (result: Array<NgSelectOptionModel>) => {
        this.makes = result;
        this.makesData = this.makes.slice(0);
        // auto selected value for makes
        if (this.searchModel.filterModel != undefined) {
          const selectedResult = this.makes.filter(
            s => s.id === this.filterModel.makeId
          );
          this.makeFilterSelected =
            selectedResult[0] == undefined
              ? { text: this.filterModel.makeId, id: null }
              : selectedResult[0];
        }
      },
      error => this.onAPIError(ProductUIMessages.LOAD_MAKES_ERROR)
    );
  }

  /**
   * Loads the list of asset types.
   */
  protected loadAssetTypes(): void {
    this.assetService.getAssetTypes().subscribe(
      (result: Array<AssetTypeModel>) => {
        this.assetTypes = result;
        this.assetTypesData = SortUtils.sortCollection(
          this.assetTypes.slice(0),
          'name'
        );
        // auto selected value
        if (this.filterModel.assetType != undefined) {
          // filterModel has only the 'name', so search the combobox data above for the entire object, & then select it
          let item = this.assetTypesData.find(e => {
            return e.name === this.filterModel.assetType;
          });
          this.selectedAssetType = Object.assign(item);
        }
      },
      error => this.onAPIError('Error while loading Asset Types.')
    );
  }

  /**
   getInactive active record
   **/
  protected getAllInactiveActive(): void {
    this.allInactiveActive = this.includeInactiveRecordsOptions;
    // auto selected value
    const selectedvalue = this.allInactiveActive.filter(
      s => s.id === this.filterModel.showInactive
    );
    this.selectedInactiveRecord = selectedvalue[0];
  }

  /**
   getAllAssetTagPresent
   **/
  protected getAllAssetTagPresent(): void {
    this.allAssetTagPresent = this.assetTagPresentOptions;
    // auto selected value
    const selectedvalue = this.allAssetTagPresent.filter(
      s => s.id === this.filterModel.assetTagPresent
    );
    this.selectedAssetTagPresent = selectedvalue[0];
  }

  /**
   * Executes the assets search.
   */
  onSearch(): void {
    this.searchModel.results = [];
    this.searchModel.pageNumber = 1;
    this.startProgress();
    // Creating a copy of the original model.
    let filterModelCopy = Object.assign({}, this.filterModel);
    this.originalData = null;
    for (let property of this.searchParamsToEncode) {
      if (
        filterModelCopy[property] !== undefined &&
        filterModelCopy[property] !== null &&
        filterModelCopy[property] !== ''
      ) {
        if (property === 'tag' || property === 'serialNumber') {
          filterModelCopy[property] = encodeURIComponent(
            `"${filterModelCopy[property]}"`
          );
        } else {
          filterModelCopy[property] = encodeURIComponent(
            filterModelCopy[property]
          );
        }
      }
    }
    // Set the Original Filter Model
    this.searchModel.filterModel = filterModelCopy;
    this.searchModel.assetStoreFilter.selectedAssetType = this.selectedAssetType;
    this.searchModel.assetStoreFilter.selectedCustomer = this.selectedCustomerType;
    this.searchAssets();
    this.finishProgress();
  }
  onSearchByAssetID(): void {
    this.startProgress();
    this.searchAssetById();
    this.finishProgress();
  }

  /**
   *  Resets the search form
   */
  onReset() {
    this.noResults = false;
    this.filterModel = Object.assign(new AssetFilterModel());
  }

  /**
   * Take the user to the Add view
   */
  onAddItem() {
    this.assetService.setAssetSearchInput(this.searchModel);
    this.router.navigate([`/console/${AssetRoutingStates.LIST.url}/add`]);
  }

  /**
   * Deletes all the selected assets in the search result view.
   */
  onDeleteItems(): void {
    this.deleting = true;
    let deleteAssetMessages = this.getDeleteAssetMessages();
    this.dialogService
      .open(ConfirmationComponent, [
        {
          provide: ConfirmationModel,
          useValue: new ConfirmationModel(
            deleteAssetMessages.MESSAGE,
            deleteAssetMessages.CONFIRMATION
          )
        }
      ])
      .then(confirmed => {
        if (confirmed) {
          this.assetService.deleteListOfAssets(this.selectedRows).subscribe(
            (res: any) => {
              this.manualRefreshAssetResults();
              this.deleting = false;
              this.toastr.success(deleteAssetMessages.SUCCESS);
            },
            () => {
              this.onAPIError(deleteAssetMessages.ERROR);
            }
          );
        }
      })
      .catch(() => {
        this.deleting = false;
      });
  }

  /**
   * Activates all the selected assets in the search result view.
   */
  onActivateItems(): void {
    this.deleting = true;
    let bulkMessages = this.getActivateAssetMessages();
    this.dialogService
      .open(ConfirmationComponent, [
        {
          provide: ConfirmationModel,
          useValue: new ConfirmationModel(
            bulkMessages.MESSAGE,
            bulkMessages.CONFIRMATION
          )
        }
      ])
      .then(confirmed => {
        if (confirmed) {
          this.assetService
            .activateListOfAssets(this.inactiveSelectedRows)
            .subscribe(
              (res: any) => {
                this.manualRefreshAssetResults(true);
                this.deleting = false;
                this.toastr.success(bulkMessages.SUCCESS);
              },
              () => {
                this.onAPIError(bulkMessages.ERROR);
              }
            );
        }
      })
      .catch(result => {
        if (result) {
          console.error(result);
        }
        this.deleting = false;
      });
  }

  /**
   * Manually change the state of the assets modified or remove it from the result list.
   */
  private manualRefreshAssetResults(reactivationPerformed = false): void {
    if (reactivationPerformed) {
      // set it to isActive = true
      let activatedAssets: Array<number> = this.inactiveSelectedRows.map(
        asset => asset.id
      );
      this.searchModel.results = [...this.searchModel.results].map(row => {
        let newItem = { ...row };
        newItem.isActive =
          activatedAssets.findIndex(item => item === newItem.id) === -1
            ? newItem.isActive
            : true;
        return newItem;
      });
    } else {
      if (this.filterModel.showInactive) {
        // set it to isActive = false
        let removedAssetIds: Array<number> = this.selectedRows.map(
          asset => asset.id
        );
        this.searchModel.results = [...this.searchModel.results].map(row => {
          let newItem = { ...row };
          // if newItem is not part of the current removed assets set isActive to true, otherwise false.
          newItem.isActive =
            removedAssetIds.findIndex(item => item === newItem.id) === -1
              ? newItem.isActive
              : false;
          return newItem;
        });
      } else {
        // remove assets from results
        let removedAssetIds: Array<number> = this.selectedRows.map(
          asset => asset.id
        );
        this.searchModel.results = [...this.searchModel.results].filter(
          row => removedAssetIds.findIndex(item => item === row.id) === -1
        );
      }
    }
  }

  onFullscreenMode(): void {
    this.fullScreen = !this.fullScreen;
  }

  /**
   *  Performs a search for an asset with the given parameters.
   */
  private searchAssets(): void {
    this.loading = true;
    this.startProgress();

    this.assetService.searchAssets(this.searchModel).subscribe(
      (res: any) => {
        if (
          res === null ||
          res.results === null ||
          (res.results && res.results.length === 0)
        ) {
          this.noResults = true;
          res.results = [];
        } else {
          this.noResults = false;
        }
        this.searchModel.results = [
          ...this.searchModel.results,
          ...res.results
        ];
        this.searchModel.filterModel = this.filterModel;
        this.originalData = [...this.searchModel.results];
        this.searchModel.assetStoreFilter = this.assetStoreFilter;
        this.assetService.setAssetSearchInput(this.searchModel);
        this.finishProgress();
        this.loading = false;
      },
      error => {
        this.noResults = true;
        if (error.error.errorCode === 122) {
          this.onAPIError(AssetUIMessages.TOO_MANY_RESULTS);
        } else {
          this.onAPIError(AssetUIMessages.SEARCH_ASSET_ERROR);
        }
        this.searchModel = new AssetSearchModel();
        this.searchModel.filterModel = this.filterModel;
        this.assetService.setAssetSearchInput(this.searchModel);
        this.finishProgress();
        this.loading = false;
      }
    );
  }

  /**
   *  Performs a search for an assetId
   */
  private searchAssetById(): void {
    this.loading = true;
    this.startProgress();
    this.assetService.searchAssetID(this.assetId).subscribe(
      (res: any) => {
        if (res === undefined) {
          this.noResults = true;
        } else {
          this.searchModel.results = [...this.searchModel.results, ...res];
        }
        this.searchModel.filterModel = this.filterModel;
        this.originalData = [...this.searchModel.results];
        this.searchModel.assetStoreFilter = this.assetStoreFilter;
        this.assetService.setAssetSearchInput(this.searchModel);
        this.finishProgress();
        this.loading = false;
      },
      error => {
        if (error.error.errorCode === 122) {
          this.onAPIError(AssetUIMessages.TOO_MANY_RESULTS);
        } else {
          this.onAPIError(AssetUIMessages.SEARCH_ASSET_ERROR);
        }
        this.searchModel = new AssetSearchModel();
        this.searchModel.filterModel = this.filterModel;
        this.assetService.setAssetSearchInput(this.searchModel);
        this.finishProgress();
        this.loading = false;
      }
    );
  }

  /**
   *  Adds the site id to the Filter Module.
   * @param site
   */
  protected onSelectSite(site): void {
    if (site) {
      this.filterModel.siteId = site.id;
      this.searchModel.filterModel = this.filterModel;
      this.assetSearchStoredInfo.site = site;
      this.assetService.setAssetSearchStoredInfo(this.assetSearchStoredInfo);
      this.assetService.setAssetSearchInput(this.searchModel);
    } else {
      this.filterModel.siteId = null;
      this.assetSearchStoredInfo.site = null;
      this.assetService.setAssetSearchStoredInfo(this.assetSearchStoredInfo);
    }
  }

  /**
   * Adds the site id to the Filter Module.
   * @param customer
   */
  protected onSelectCustomer(customer: any): void {
    if (customer) {
      // this.sitesSelect.active = [];
      this.filterModel.siteId = null;
      this.filterModel.customerId = customer.id;
      this.assetSearchStoredInfo.customer = customer;
      this.assetSearchStoredInfo.site = null;
      this.assetService.setAssetSearchStoredInfo(this.assetSearchStoredInfo);
    }
  }

  /**
   * Pass the number of selected rows
   * @param selected
   */
  protected deactivateEvent(selected: any): void {
    this.selectedRows = selected;
  }

  /**
   * Pass the number of selected rows
   * @param selected
   */
  protected activateEvent(selected: any): void {
    this.inactiveSelectedRows = selected;
  }

  /**
   * Gets a Bulk Delete Asset Message Object.
   * @returns {any}
   */
  private getDeleteAssetMessages(): AssetBulkMessages {
    return this.selectedRows.length > 1
      ? {
          MESSAGE: AssetUIMessages.DEACTIVATE_ASSETS,
          CONFIRMATION: AssetUIMessages.DEACTIVATE_BULK_ASSETS_CONFIRMATION.replace(
            '{0}',
            this.selectedRows.length.toString()
          ),
          SUCCESS: AssetUIMessages.DEACTIVATE_ASSETS_SUCCESS,
          ERROR: AssetUIMessages.DEACTIVATE_ASSETS_ERROR
        }
      : {
          MESSAGE: AssetUIMessages.DEACTIVATE_ASSET,
          CONFIRMATION: AssetUIMessages.DEACTIVATE_ASSET_CONFIRMATION.replace(
            '{0}',
            this.selectedRows[0].serialNumber
          ),
          SUCCESS: AssetUIMessages.DEACTIVATE_ASSET_SUCCESS,
          ERROR: AssetUIMessages.DEACTIVATE_ASSET_ERROR
        };
  }

  /**
   * Returns the Asset bulk activate messages Object.
   * @returns {AssetBulkMessages}
   */
  private getActivateAssetMessages(): AssetBulkMessages {
    return this.inactiveSelectedRows.length > 1
      ? {
          MESSAGE: AssetUIMessages.ACTIVATE_ASSETS,
          CONFIRMATION: AssetUIMessages.ACTIVATE_BULK_ASSETS_CONFIRMATION.replace(
            '{0}',
            this.inactiveSelectedRows.length.toString()
          ),
          SUCCESS: AssetUIMessages.ACTIVATE_ASSETS_SUCCESS,
          ERROR: AssetUIMessages.ACTIVATE_ASSETS_ERROR
        }
      : {
          MESSAGE: AssetUIMessages.ACTIVATE_ASSET,
          CONFIRMATION: AssetUIMessages.ACTIVATE_ASSET_CONFIRMATION.replace(
            '{0}',
            this.inactiveSelectedRows[0].serialNumber
          ),
          SUCCESS: AssetUIMessages.ACTIVATE_ASSET_SUCCESS,
          ERROR: AssetUIMessages.ACTIVATE_ASSET_ERROR
        };
  }

  /**
   * Determines how many assets were updated
   * @param {Array<any>} results
   */
  private getAssetUpdated(results: Array<any>): number {
    let updatedAssets = 0;
    results.forEach(element => {
      if (element.assetId !== 0) {
        updatedAssets++;
      }
    });
    return updatedAssets;
  }

  /**
   * Generates a message with the correspond count of updated assets.
   * @param {number} updatedAssets
   * @param {number} resultLength
   */
  private getAssetsUpdateInfoMsg(
    updatedAssets: number,
    resultLength: number
  ): string {
    return AssetUIMessages.EDIT_ASSETS_SUCCESS.replace(
      '{0}',
      updatedAssets.toString()
    ).replace('{1}', resultLength.toString());
  }

  /**
   * Opens a dialog to be able to edit a set of assets with the same product.
   * @param {Array<AssetModel>} selectedAssetRows
   */
  protected onAssetsProductEdit(selectedAssetRows: Array<AssetModel>): void {
    this.dialogService
      .open(ProductSelectorDialogComponent, [
        { provide: 'product', useValue: null },
        {
          provide: 'isStarbucksSite',
          useValue: this.isStarbucksSiteSelected()
        },
        { provide: 'assets', useValue: selectedAssetRows },
        { provide: 'customization', useValue: null }
      ])
      .then(result => {
        this.assetService
          .updateAssets(selectedAssetRows, result.product.id)
          .subscribe(
            res => {
              setTimeout(() => {
                this.onSearch();
              }, 300);
              if (selectedAssetRows.length === res.length) {
                this.toastr.success(
                  this.getAssetsUpdateInfoMsg(
                    this.getAssetUpdated(res),
                    res.length
                  )
                );
              } else {
                this.onAPIError(AssetUIMessages.EDIT_ASSET_ERROR);
              }
            },
            () => {
              this.onAPIError(AssetUIMessages.EDIT_ASSET_ERROR);
            }
          );
      })
      .catch(err => {
        // On Cancel Close
      });
  }

  /**
   * Filters Makes combox items by input value.
   * @param value
   */
  protected handleMakesComboBoxFilter(value) {
    this.makesData = this.makes.filter(
      s => s.text.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  protected handleAssetTagPresentComboBoxFilter(value) {
    this.allAssetTagPresent = this.assetTagPresentOptions.filter(
      s => s.text.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  protected handleActiveInActiveComboBoxFilter(value) {
    this.allInactiveActive = this.includeInactiveRecordsOptions.filter(
      s => s.text.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  protected handleCustomersComboBoxFilter(value) {
    let temp = this.allCustomersData.filter(row => {
      return row.text
        ? row.text.toLowerCase().indexOf(value.toLowerCase()) !== -1 || !value
        : '';
    });

    this.allCustomers = value !== '' ? temp : this.allCustomersData;
  }

  /**
   * Selects a make in the kendo combo box.
   * @param make
   */
  protected onSelectedMake(make: NgSelectOptionModel): void {
    if (make !== undefined && make.text) {
      this.filterModel.makeId = make.id;
      this.filterModel.make = make.text;
    } else {
      this.filterModel.makeId = null;
      this.makeFilterSelected = null;
      this.filterModel.make = null;
      this.handleMakesComboBoxFilter('');
    }
  }

  /**
   * Filters Makes combox items by input value.
   * @param value
   */
  protected handleAssetTypeComboBoxFilter(value) {
    this.assetTypesData = this.assetTypes.filter(
      s => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  /**
   * Sets the Make field on the product model.
   * @param type
   */
  /**
   * Sets assetType name with required selection.
   */
  public valueChangeAssetTypes(filter: any): void {
    if (filter) {
      this.filterModel.assetType = filter.name;
      this.assetStoreFilter.selectedAssetType = filter;
    } else {
      this.filterModel.assetType = null;
    }
  }

  protected onSelectedonAssetTagPresent(type: any): void {
    if (type) {
      this.filterModel.assetTagPresent =
        type.id === 'trueAndFalse' ? '' : type.id;
    } else {
      this.filterModel.assetTagPresent = '';
    }
  }

  protected onSelectedActiveRecord(type: any): void {
    if (type) {
      this.filterModel.showInactive =
        type.id === true ? true : type.id === false ? false : false;
    } else {
      this.filterModel.showInactive = null;
    }
  }

  protected valueNormalizer = (text: Observable<string>) =>
    text.pipe(
      map((description: string) => {
        return {
          text: description
        };
      })
    );

  /**
   * Sets customerId with required selection.
   */
  public valueChangeCustomer(filter: any): void {
    if (filter) {
      this.filterModel.customerId = filter.id;
      this.assetStoreFilter.selectedCustomer = filter;
      this.filterModel.siteId = null;
      this.assetSearchStoredInfo.customer = filter;
      this.assetSearchStoredInfo.site = null;
    } else {
      this.filterModel.customerId = null;
      this.filterModel.siteId = null;
      this.assetSearchStoredInfo.customer = null;
      this.assetSearchStoredInfo.site = null;
    }
  }
  /**
   * Generic Function to validate the inputbox to allow/prevent entering input in the input/search box
   * @param item
   * */
  onInput(item) {
    return !item || item.length === 0 ? true : false;
  }

  infinityScroll(): void {
    if (!this.loading) {
      this.searchModel.pageNumber += 1;
      this.searchAssets();
    }
  }
}
